import { MODULE_NAME as AUDIENCE_INSIGHTS_MODULE } from 'modules/audience-insights/config/routes';
import { MODULE_NAME as AUDIENCES_MODULE } from 'modules/audiences/config/routes';
import { MODULE_NAME as BILLING_MODULE } from 'modules/billing-and-payments/config/routes';
import { MODULE_NAME as CREATIVE_LIBRARY_MODULE } from 'modules/creative-library/config/routes';
import { MODULE_NAME as PERFORMANCE_RULES_MODULE } from 'modules/performance-rules/config/routes';
import { MODULE_NAME as SCHEDULED_REPORTS } from 'modules/scheduled-reports/config/routes';
import { MODULE_NAME as TRACKING_MODULE } from 'modules/tracking/config/routes';
import { CAMPAIGN_DIMENSION } from 'services/campaignDimension';
import { getModuleName } from 'services/url/urlParams';
import { MODULE_NAME as PUSH_API_MODULE } from '../../push-api/config/routes/module';
import { CONVERSIONS_REPORT_ID } from '../modules/campaigns-reports/config/reports/conversions/conversionsReportId';
import { CREATIVE_LIBRARY_REPORT_ID } from '../modules/campaigns-reports/config/reports/creative-library/creativeLibraryReportId';
import { DAY_VIDEO_REPORT_ID } from '../modules/campaigns-reports/config/reports/day-video/dayVideoReportId';
import { DAY_REPORT_ID } from '../modules/campaigns-reports/config/reports/day/dayReportId';
import { PAYMENTS_REPORT_ID } from '../modules/campaigns-reports/config/reports/payments/paymentsReportId';
import { PERFORMANCE_RULES_REPORT_ID } from '../modules/campaigns-reports/config/reports/performance-rules/performanceRulesReportId';
import { PIXEL_BASED_REPORT_ID } from '../modules/campaigns-reports/config/reports/pixel-based/pixelBasedReportId';
import { PUSH_API_REPORT_ID } from '../modules/campaigns-reports/config/reports/push-api/pushApiReportId';
import { SCHEDULED_REPORTS_REPORT_ID } from '../modules/campaigns-reports/config/reports/scheduled-reports/scheduledReportsReportId';
import { SEGMENT_CATEGORY_REPORT_ID } from '../modules/campaigns-reports/config/reports/segment-category/segmentCategoryReportId';
import { TODAY_REPORT_ID } from '../modules/campaigns-reports/config/reports/today/todayReportId';
import { isRealTimeReport } from './isRealTimeReport';

const DEFAULT_REPORT_MAP = {
    [CAMPAIGN_DIMENSION.SPONSORED]: DAY_REPORT_ID,
    [CAMPAIGN_DIMENSION.VIDEO]: DAY_VIDEO_REPORT_ID,
};

export const getDefaultReportId = (dimension = CAMPAIGN_DIMENSION.SPONSORED) => {
    const module = getModuleName();

    if (module === TRACKING_MODULE) {
        return CONVERSIONS_REPORT_ID;
    }
    if (module === AUDIENCES_MODULE) {
        return PIXEL_BASED_REPORT_ID;
    }
    if (module === AUDIENCE_INSIGHTS_MODULE) {
        return SEGMENT_CATEGORY_REPORT_ID;
    }
    if (module === BILLING_MODULE) {
        return PAYMENTS_REPORT_ID;
    }
    if (module === PERFORMANCE_RULES_MODULE) {
        return PERFORMANCE_RULES_REPORT_ID;
    }
    if (module === SCHEDULED_REPORTS) {
        return SCHEDULED_REPORTS_REPORT_ID;
    }
    if (module === PUSH_API_MODULE) {
        return PUSH_API_REPORT_ID;
    }
    if (module === CREATIVE_LIBRARY_MODULE) {
        return CREATIVE_LIBRARY_REPORT_ID;
    }
    if (isRealTimeReport()) {
        return TODAY_REPORT_ID;
    }

    return DEFAULT_REPORT_MAP[dimension] || DAY_REPORT_ID;
};
